import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class NewCategoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            name: '',
            parentId: '',
            categories: TotemActions.getCategories()
        };
    }

    componentWillMount() {
        TotemStore.on('CATEGORIES_RECEIVED', this._onReceiveCategories.bind(this));
    }

    _onReceiveCategories() {
        this.setState({
            categories: TotemStore.getCategories()
        });
    }

    _handleCreateCategory() {
        let { name, parentId } = this.state;
        this.setState({
            loading: true
        });
        TotemActions.addCategory(name, parentId, this.newCategoryCallback.bind(this));
    }

    newCategoryCallback() {
        this.setState({
            loading: false
        });
        this.props.categorySaved();
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            isValid: (this.state.name !== '')
        });
    }

    _onCancelModal() {
        this.setState({
            name: '',
            parentId: '',
            categories: []
        });
        this.props.cancelModal()
    }

    render() {

        let { categories } = this.state;

        let categoriesOptions = [];

        if (categories) {
            categoriesOptions = categories.map((category) => {
                let key = new Date().getUTCMilliseconds() * category.id;
                return <option value={category.id} key={key}>{category.name}</option>
            });
        }

        return (
            <div id="createCategory" className="modal">
                <div className="modal-content">
                    <h5>Agregar nueva categoría</h5>
                    <div className="row">
                        <div className="input-field col s12 m6">
                            <select className="browser-default" name="parentId" value={this.state.parentId} onChange={this._handleInputChange.bind(this)}>
                                <option value="" disabled>Categoría padre</option>
                                {categoriesOptions}
                            </select>
                        </div>
                        <div className="input-field col s12 m6">
                            <input type="text" name="name" value={this.state.name} onChange={this._handleInputChange.bind(this)} />
                            <label htmlFor="name">Nombre de la nueva categoría</label>
                        </div>
                    </div>
                </div>
                <div className="modal-footer right-align">
                    <a className="waves-effect waves-light btn  red darken-4" onClick={this._onCancelModal.bind(this)}>Cancelar</a>
                    <a className={this.state.isValid ? 'waves-effect waves-light btn blue darken-3' : 'waves-effect waves-light btn blue darken-3 disabled'} onClick={this._handleCreateCategory.bind(this)}>Guardar</a>
                </div>
            </div>
        );
    }
}

export default NewCategoryComponent;


// WEBPACK FOOTER //
// ./src/components/NewCategoryComponent.js